/**
 * Buttons
 */
export enum EAvailabilityType {
  ADD_TO_CART = 'ADD_TO_CART',
  PURCHASE_CD = 'PURCHASE_CD',
  DISCONTINUED = 'DISCONTINUED',
}

export enum EApcButtonType {
  ADD_TO_CART = 'ADD_TO_CART',
  DOWNLOAD_BUTTON = 'DOWNLOAD_BUTTON',
}

export const ADD_TO_CART_EXCEPTION_CODES = {
  MAXIMUM_COUNT_WITH_LINK: 'maximumCartCountWithLinkError',
  MAXIMUM_COUNT: 'maximumCartCountError',
};

export const PLACEHOLDERS = {
  HOST: '#apcHost#',
  COUNTRY: '#countryCode#',
  LANGUAGE: '#languageCode#',
  FAVORITES_LINK: '{favorites-link}',
  PRODUCT_ID: '#productId#',
  SKUS: '#skus#',
  QTY: '#qty#',
  Chat_CSC_ID: '#Chat_CSC_ID#',
};

const QUERY_LOCALES = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;
const QUERY_LOCALES_WITHOUT_CHAT = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}`;
const SKU_LIST = `&SKU_List=${PLACEHOLDERS.SKUS}`;
const QTY_LIST = `&qty_list=${PLACEHOLDERS.QTY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;

export const URLS = {
  ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrder?${QUERY_LOCALES}`,
  GO_TO_CART: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/cart/shoppingCart.jsp`,
  PRODUCT_AVAILABILITY: `${PLACEHOLDERS.HOST}/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo?partNumbersList=${PLACEHOLDERS.PRODUCT_ID}&${QUERY_LOCALES}`,
  ADD_TO_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToFavorites?${QUERY_LOCALES}`,
  REMOVE_FROM_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/removeItemFromFavorites?${QUERY_LOCALES}`,
  MY_LIST: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/myaccount/myAccountMyList.jsp`,
  CREATE_ACCOUNT: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}&type=reg`,
  SIGN_IN: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}`,
  ADD_TO_CART_SUCCESS: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderSuccess?${QUERY_LOCALES}`,
  ADD_TO_CART_ERROR: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderError?${QUERY_LOCALES}`,
  COMPARISON_ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemsToOrder?${QUERY_LOCALES_WITHOUT_CHAT}${SKU_LIST}${QTY_LIST}`,
};
